import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery, PAGE_SIZE } from '../common';
import { IFacility, IFacilitiesFilter } from './models';

export const facilitiesApiSlice = createApi({
  reducerPath: 'facilities/api',
  baseQuery: axiosBaseQuery({
    baseUrl: 'facilities/',
  }),
  endpoints: builder => ({
    getFacilities: builder.query<IState<IFacility>, IFacilitiesFilter>({
      query: data => ({
        url: `fn/search`,
        method: 'POST',
        data,
      }),
      keepUnusedDataFor: 0,
      transformResponse: (response: IAxiosResponse<IFacility[]>): IState<IFacility> => ({
        data: [...response.data],
        isEnd: response?.data && response?.data?.length < PAGE_SIZE,
      }),
      serializeQueryArgs: ({ endpointName }) => {
        return endpointName;
      },
      merge(currentCacheData, responseData, otherArgs) {
        if (otherArgs.arg?.skip && otherArgs.arg.skip > 0) {
          responseData.data.unshift(...currentCacheData.data);
          return responseData;
        }
        return responseData;
      },
    }),
  }),
});
